import { useContext, useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ColorContext } from './ColorContext/darkContext';
import Home from './Components/Home/Home';
import CategoryForm from './Components/CategoryForm/CategoryForm';
import Orders from './Components/Orders/Orders';
import AddNew from './Pages/AddNew/AddNew';
import BlogDetail from './Pages/BlogDetail/BlogDetail';
import Blogs from './Pages/Blogs/Blogs';
import Detail from './Pages/Detail/Detail';
import Login from './Pages/Login/Login';
import ForgetPassword from './Pages/ForgetPassword/ForgetPassword';
import Lists from './Pages/UserLists/UserLists';
import PrivateRoute from './Components/PrivateRoute';
import ProductForm from './Pages/Form/ProductFrom';
import Categories from './Pages/Categories/Categories';
import Profile from './Pages/Profile/Profile';
import Settings from './Pages/Settings/Settings';
import Finance from './Pages/Finance/Finance';
import Billings from './Pages/Billings/Billings';
import UsersList from './Pages/UsersList/UsersList';
import Tables from './Pages/Tables/Tables';
import TableForm from './Components/TableForm/TableForm';
import Customers from './Pages/Customers/Customers';
import NotFound from './Pages/NotFound';
import AdminLogin from './Pages/AdminLogin/AdminLogin';
import Inventory from './Pages/Inventory/Inventory';
import OrdersReport from './Pages/OrdersReport/OrdersReport';
import Formulation from './Pages/Formulation/Formulation';
import SalesComparison from './Pages/SalesComparison/SalesComparison';
import './app.css';

// Dynamicaly change the data for different pages(replaceable)
const userInpDetails = [
    {
        id: 2,
        name: 'username',
        lable: 'Username',
        type: 'text',
        placeholder: 'John23',
        required: true,
        pattern: '^[A-Za-z0-9]{3,12}$',
        errorMsg: 'Username should be 3-12 characters & should not include any special character!',
    },
    {
        id: 3,
        name: 'name',
        lable: 'Name',
        type: 'text',
        placeholder: 'John Smith',
        required: true,
        pattern: '^[A-Za-z]{1,20}$',
        errorMsg: 'Name is required!',
    },
    {
        id: 4,
        name: 'email',
        lable: 'Email',
        type: 'email',
        placeholder: 'example@email.com',
        required: true,
        errorMsg: 'Enter a valid email!',
    },
    {
        id: 5,
        name: 'password',
        lable: 'Password',
        type: 'password',
        placeholder: 'Password',
        required: true,
        pattern: '^(?=.*[0-9])(?=.*[A-Za-z])(?=.*[!@#$%^&*()_+])[A-Za-z0-9!@#$%^&*()_+]{6,20}$',
        errorMsg:
            'Password should be 6-20 characters and include at last 1 num, 1 letter, 1 special character!',
    },
    {
        id: 6,
        name: 'address',
        lable: 'Address',
        type: 'text',
        placeholder: 'Address',
        required: true,
        errorMsg: 'Address is required!',
    },
];
const productInpDetails = [
    {
        id: 2,
        name: 'title',
        lable: 'Title',
        type: 'text',
        placeholder: 'Product title',
        required: true,
        errorMsg: 'Title is required!',
    },
    {
        id: 3,
        name: 'description',
        lable: 'Description',
        type: 'text',
        placeholder: 'Product description',
        required: true,
        errorMsg: 'Description is required!',
    },
    {
        id: 4,
        name: 'category',
        lable: 'Category',
        type: 'text',
        placeholder: 'Product category',
        required: true,
        errorMsg: 'Category is required!',
    },
    {
        id: 5,
        name: 'price',
        lable: 'Price',
        type: 'number',
        placeholder: 'Product price',
        required: true,
        errorMsg: 'Price is required!',
    },
    {
        id: 6,
        name: 'stock',
        lable: 'In Stock',
        type: 'text',
        placeholder: 'In Stock',
        required: true,
        errorMsg: 'This field is required!',
    },
];
const blogInputs = [
    {
        id: 1,
        name: 'title',
        lable: 'Title',
        type: 'text',
        placeholder: 'Blog title',
        required: true,
        errorMsg: 'Title is required!',
    },
    {
        id: 2,
        name: 'description',
        lable: 'Description',
        type: 'text',
        placeholder: 'Blog description',
        required: true,
        errorMsg: 'Description is required!',
    },
    {
        id: 3,
        name: 'tags',
        lable: 'Tags',
        type: 'text',
        placeholder: 'Travel, Communication',
        required: true,
        errorMsg: 'Tag is required!',
    },
];

function App() {
    const { darkMode } = useContext(ColorContext);
    const { i18n } = useTranslation();
    const direction = i18n.language === 'fa' ? 'rtl' : 'ltr';

    useEffect(() => {
        document.documentElement.lang = i18n.language;
        document.documentElement.dir = direction;
    }, [direction, i18n.language]);

    return (
        <div className={darkMode ? 'App dark' : 'App'} dir={direction}>
            <BrowserRouter>
                <Routes>
                    {/* Public Route */}
                    <Route path="/login" element={<Login />} />
                    <Route path="/forget-password" element={<ForgetPassword />} />

                    {/* Protected Routes */}
                    <Route path="/" element={<PrivateRoute />}>
                        <Route index element={<Home />} />

                        <Route path="users">
                            <Route index element={<Lists type="user" />} />
                            <Route path=":userId" element={<Detail />} />
                            <Route
                                path="addnew"
                                element={
                                    <AddNew
                                        inputs={userInpDetails}
                                        titlee="Add New User"
                                        type="USER"
                                    />
                                }
                            />
                        </Route>
                        <Route path="UsersList" element={<UsersList />} />
                        <Route
                            path="YouMustNotBeAtThisEndpointGoBackOrYouWillGetNothing"
                            element={<AdminLogin />}
                        />
                        <Route path="Profile" element={<Profile />} />
                        <Route path="Finance" element={<Finance />} />
                        <Route path="Settings" element={<Settings />} />
                        <Route path="Orders" element={<Orders />} />
                        <Route path="OrdersReport" element={<OrdersReport />} />
                        <Route path="SalesComparison" element={<SalesComparison />} />
                        <Route path="Billings" element={<Billings />} />
                        <Route path="Customers" element={<Customers />} />
                        <Route path="invntory" element={<Inventory />} />
                        <Route path="Formulation" element={<Formulation />} />
                        <Route path="Tables">
                            <Route index element={<Tables />} />
                            <Route path="addnew" element={<TableForm />} />
                        </Route>
                        <Route path="categories">
                            <Route index element={<Categories />} />
                            <Route path="addnew" element={<CategoryForm />} />
                        </Route>

                        <Route path="products">
                            <Route index element={<Lists type="product" />} />
                            <Route path=":productId" element={<Detail />} />
                            <Route path="addnew" element={<ProductForm />} />
                        </Route>

                        <Route path="blogs">
                            <Route index element={<Blogs type="blog" />} />
                            <Route path=":blogId" element={<BlogDetail />} />
                            <Route
                                path="addnew"
                                element={
                                    <AddNew inputs={blogInputs} titlee="Add New Blog" type="BLOG" />
                                }
                            />
                        </Route>
                    </Route>
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
